/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CaretUpIcon(props: IconProps) {
    return <IconWrapper {...props}>{<path d="M12.014 26h16.013c1.759 0 2.638-2.128 1.382-3.38l-7.975-8.01a1.94 1.94 0 0 0-2.826 0l-7.975 8.01c-1.32 1.252-.44 3.38 1.381 3.38"/>}</IconWrapper>;
}
